import React, { useState, useRef, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './App.css';
import About from './About';
import Services from './Designs';
import Suppliers from './Suppliers';
import Contact from './Contact';


function App() {
  let bgImage = './bg.jpg';
  const [expandedService, setExpandedService] = useState(null);
  const [currentPage, setCurrentPage] = useState('home');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');
  const form = useRef();

  const toggleService = (index) => {
    setExpandedService(expandedService === index ? null : index);
  };

  useEffect(() => {
    emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    console.log('Sending email with:', {
      serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
      templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    });

    emailjs.sendForm(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID, 
      form.current,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
    .then((result) => {
      console.log('Email sent successfully:', result);
      setSubmitStatus('Message sent successfully!');
      form.current.reset();
    })
    .catch((error) => {
      console.error('Email send failed:', error);
      setSubmitStatus('Failed to send message. Please try again.');
    })
    .finally(() => {
      setIsSubmitting(false);
    });
  };

  const services = [
    {
      title: 'Home Health Consultation',
      details: 'We guide agencies in setting up and improving home health operations to meet regulatory and clinical standards. Our support ensures quality patient care and strong operational performance.'
    },
    {
      title: 'Hospice Care Consultation',
      details: 'We help hospice providers establish compliant, compassionate care services aligned with federal and state guidelines. Our guidance strengthens patient outcomes and agency readiness.'
    },
    {
      title: 'Home Care Consultation',
      details: 'We assist home care agencies in improving service delivery, staffing, and workflow efficiency. Our consultation ensures compliance and smooth operational growth.'
    },
    {
      title: 'Survey Readiness',
      details: 'We prepare agencies for state and federal surveys through mock audits, documentation review, and process improvements. This ensures confidence and compliance on survey day.'
    },
    {
      title: 'Quality Assurance',
      details: 'We develop ongoing QA programs to help agencies monitor performance, correct deficiencies, and elevate care standards. Our approach builds consistency and long-term improvement.'
    },
    {
      title: 'ADR/Appeal',
      details: 'We support agencies in responding to ADRs and managing appeals with accurate clinical and billing documentation. Our assistance increases the chances of successful claim recovery.'
    },
    {
      title: 'Order Management',
      details: 'We streamline the physician order process to ensure timely completion, accuracy, and proper filing. This reduces delays and risk of survey deficiencies.'
    },
    {
      title: 'Billing Process',
      details: 'We optimize the billing workflow to reduce claim errors, improve reimbursement rates, and speed up cash flow. Our solutions help agencies maintain financial stability and efficiency.'
    }
  ];
  if (currentPage === 'about') {
    return <About setCurrentPage={setCurrentPage} />;
  }

  if (currentPage === 'designs') {
    return <Services setCurrentPage={setCurrentPage} />;
  }

  if (currentPage === 'suppliers') {
    return <Suppliers setCurrentPage={setCurrentPage} />;
  }

  if (currentPage === 'contact') {
    return <Contact setCurrentPage={setCurrentPage} />;
  }

  return (
    <div className="App">
      <header className="header">
        <div className="container">
          <div className="logo">
            <span className="logo-icon"><img src='./s.png' className='logoimage'></img></span>
          </div>
          <nav className="nav">
            <a href="#home" onClick={() => setCurrentPage('home')}>Home</a>
            <a href="#about" onClick={() => setCurrentPage('about')}>About</a>
            <a href="#services" onClick={() => setCurrentPage('designs')}>Services</a>
                      <a href="#contact" onClick={() => setCurrentPage('contact')}>Contact</a>
          </nav>
        </div>
      </header>

      <main className="hero" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${bgImage})` }}>
        <div className="hero-content">
          <h1 className="animated-text">
            Specialized Provider of<br />
            Comprehensive Healthcare<br />
            Consulting Services
          </h1>
        </div>
      </main>

      <section className="welcome-section">
        <div className="container">
          <div className="welcome-content">
            <div className="welcome-image">
              <img src="./vertical.png" alt="Data Center" />
            </div>
            <div className="welcome-text">
              <h3>Welcome To</h3>
              <h2>ZM Consulting Services</h2>
              <div className="divider"></div>
              <p>
                ZM Consulting Services is a comprehensive support partner for healthcare agencies, offering expert guidance across every stage of operations. Their team provides professional Home Health, Hospice, and Home Care consultation to help agencies establish compliant, patient-focused services. They assist organizations in preparing for state and federal Survey Readiness, ensuring strong regulatory performance. With specialized Quality Assurance programs, ADR and Appeal support, and efficient Order Management solutions, ZM Consulting Services helps agencies maintain accuracy, compliance, and timely workflows. Their streamlined Billing Process services further improve reimbursement success, allowing providers to focus on delivering exceptional care.
              </p>
              <p>
                Our scope covers the full operational lifecycle of home-based healthcare agencies, from initial setup to ongoing compliance and performance improvement. We support clinical, administrative, and regulatory functions, helping organizations strengthen service delivery, streamline processes, and maintain consistent quality standards. Our goal is to empower agencies to operate efficiently, stay compliant, and provide the highest level of patient care.
              </p>

              <button className="read-more-btn" onClick={() => setCurrentPage('designs')}>View Our Services</button>
            </div>
          </div>
        </div>
      </section>

      <section className="help-section">
        <div className="container">
          <h2 className="section-title">How May I Help You?</h2>
          <div className="help-grid">
            <div className="help-item">
              <div className="help-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="#e53e3e">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#e53e3e" strokeWidth="2" fill="none" />
                  <path d="M7.5 12L10 14.5L16.5 8" stroke="white" strokeWidth="2" fill="none" />
                  <circle cx="12" cy="12" r="9" fill="#e53e3e" />
                  <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" fill="none" />
                </svg>
              </div>
              <h3>Our Mission</h3>
              <p>
               To support healthcare agencies with reliable, compliant, and efficient solutions that enhance patient care, improve operational performance, and strengthen long-term success.
              </p>
            </div>
            <div className="help-item">
              <div className="help-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="#e53e3e">
                  <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                </svg>
              </div>
              <h3>Our Vision</h3>
              <p>
                To be a trusted leader in healthcare consulting, recognized for innovation, excellence, and meaningful impact in the home-based care industry.
              </p>
            </div>
            <div className="help-item">
              <div className="help-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="#e53e3e">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                  <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" fill="none" />
                </svg>
              </div>
              <h3>Our Culture</h3>
              <p>
                We value integrity, collaboration, and continuous improvement, working closely with clients through a professional and supportive approach that ensures growth, trust, and shared success.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="what-we-do-section">
        <div className="container">
          <div className="what-we-do-content">
            <div className="what-we-do-text">
              <div className="divider"></div>
              <h2>What we do</h2>
              <div className="services-list">
                {services.map((service, index) => (
                  <div key={index} className="service-item">
                    <div className="service-header" onClick={() => toggleService(index)}>
                      <span className={`arrow ${expandedService === index ? 'expanded' : ''}`}>▶</span>
                      <span>{service.title}</span>
                    </div>
                    {expandedService === index && (
                      <div className="service-details">
                        {Array.isArray(service.details) ? (
                          <ul>
                            {service.details.map((detail, i) => (
                              <li key={i}>{detail}</li>
                            ))}
                          </ul>
                        ) : (
                          <p>{service.details}</p>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
              
            </div>
            <div className="contact-form">
              <form ref={form} onSubmit={sendEmail}>
                <div className="form-row">
                  <div className="form-group">
                    <label>First Name *</label>
                    <input type="text" name="first_name" required />
                  </div>
                  <div className="form-group">
                    <label>Last Name *</label>
                    <input type="text" name="last_name" required />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Your Email *</label>
                    <input type="email" name="user_email" required />
                  </div>
                  <div className="form-group">
                    <label>Phone</label>
                    <input type="tel" name="phone" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Your Message *</label>
                  <textarea rows="5" name="message" required></textarea>
                </div>
                <button type="submit" className="submit-btn mt-3" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Submit'}
                </button>
                {submitStatus && (
                  <div className={`submit-status ${submitStatus.includes('success') ? 'success' : 'error'}`}>
                    {submitStatus}
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <span>Copyright © 2025 ZM Consulting Services</span>
            <span>Powered by ZM Consulting Services</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;